import React from 'react';
import { featureSpecs } from '../../data/featureSpecs';

/** Technical specifications paired with the core benefit: fixed positions + exchangeable lights. */
export function SpecSheet() {
  return <section aria-labelledby="specs-title" className="border-t mf-hairline bg-navy" data-id="element-368" data-mp="214feuahqbhgm">
      <div className="mx-auto grid max-w-site gap-12 px-5 py-20 md:px-8 md:py-24 lg:grid-cols-[1fr_2fr] lg:gap-16" data-id="element-369" data-mp="1x2u8l7zpa1fe">
        <div data-id="element-370" data-mp="19c805flsaf4v">
          <p className="font-display text-lg uppercase tracking-[0.14em] text-titanium" data-id="element-371" data-mp="19dstj1wd3s15">M1 PRO specifications</p>
          <h2 id="specs-title" className="mt-3 font-display text-4xl font-semibold uppercase leading-[0.95] md:text-5xl" data-id="element-372" data-mp="14fhl8vlptpl1">
            Professional-grade lighting. <span className="text-ice" data-id="element-373" data-mp="1deuxtx54yu9z">Built for the elements.</span>
          </h2>
          <p className="mt-5 text-titanium" data-id="element-374" data-mp="2tsusotp4jtqd">
            Every specification serves one idea: permanent mounting positions with rechargeable lights you can exchange in
            seconds.
          </p>
        </div>
        <dl className="grid grid-cols-2 gap-px overflow-hidden border mf-hairline bg-white/10 md:grid-cols-4" data-id="element-375" data-mp="3409ww8pk783m">
          {featureSpecs.map(s => <div key={s.label} className="flex flex-col bg-navy p-5" data-id="element-376" data-mp="37zs8uezek8ub">
              <dt className="order-2 mt-2 text-sm leading-snug text-titanium" data-id="element-377" data-mp="3d1pz3t6803wr">
                {s.label}
                {s.note && <span className="mt-1 block text-xs text-titanium/70" data-id="element-378" data-mp="3hz9c6pr6man4">{s.note}</span>}
              </dt>
              <dd className="order-1 font-display text-3xl font-semibold uppercase leading-none text-white" data-id="element-379" data-mp="2kdlsn5ftrmt0">
                {s.value}
                {s.unit && <span className="ml-1 text-base text-ice" data-id="element-380" data-mp="2uagnnecw352j">{s.unit}</span>}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}